/**
 * 云 RBP 菜单/门店设置项 ID（与 RBP2 `tool-setting.constant` 数值一致，供娱乐项目管理等模块复用）
 */
export const RBP_MENU_SETTINGS = {
    /** 绑定费用菜单设置 ID */
    BIND_COST: 1,
    /** 额外费用菜单设置 ID */
    EXTRA_COST: 147,
    /** 娱乐项目管理一级菜单绑定 ID */
    PARK_MODE: 148,
    /** 娱乐项目预订时间（逗号分隔 HH:mm） */
    PARK_MODE_BOOKING_TIME: 149,
    /** 使用条款及规则（JSON：title + content） */
    PARK_MODE_TERMS_CONDITIONS: 150,
    /** 隐私政策 */
    PARK_MODE_PRIVACY_POLICY: 151,
    /** 免责声明 */
    PARK_MODE_DISCLAIMER: 152,
} as const;

/**
 * `get_menus_v3` 的 `type` 参数（与 RBP2 `MENU_SETTINGS_TYPE` 一致）
 */
export const RBP_MENU_SETTINGS_TYPE = {
    BIND_COST: 1,
    EXTRA_COST: 2,
    PARK_MODE: 3,
} as const;
